import ApisClient, { ApisClientNoLoader } from '../utils/client/ApisClient';
import { ContactInfo, Order, OrderList, Slot } from '../models/Orders';

export const getOrders = ({ page, size }: { page: number; size: number }) => {
    return ApisClientNoLoader.get<OrderList>(`/orders?pageNumber=${page}&pageSize=${size}`);
};

export const getOrderDetail = (id?: string) => {
    return ApisClient.get<Order>(`/orders/detail?customerOrderId=${id}`);
};

export const getAvailableAppointments = (workId: string) => {
    return ApisClient.get<Slot[]>(`/orders/appointments/available?workId=${workId}`);
};

export const updateAppointment = (workId: string, appointmentId: string, appointment: Slot) => {
    return ApisClient.post(`/orders/appointments/update?workId=${workId}&appointmentId=${appointmentId}`, appointment);
};

export const cancelAppointment = (workId: string, appointmentId: string) => {
    return ApisClient.post(`/orders/appointments/cancel?workId=${workId}&appointmentId=${appointmentId}`);
};

export const updateAppointmentContact = (contact: ContactInfo) => {
    return ApisClient.post('/orders/appointments/update-contact', contact);
};
